export default __webpack_public_path__ + "static/media/great.f046b51b.gif";